import request from '@/utils/request';

export function login(params) {
    return request({
        url: '/employee/login',
        method: 'post',
        params
    });
}

export function getInfo(params) {
    return request({
        url: '/employee/loginEmpDetail',
        method: 'get',
        params
    });
}

export function logout(params) {
    return request({
        url: '/employee/logout',
        method: 'get',
        params: params
    });
}

export function employeeModule(params) {
    return request({
        url: '/employee/getEmployeeModule',
        method: 'get',
        params: params
    });
}
